export const allProjects = [
  {
    id: 1,
    slug: "maruti-shree",
    name: "Maruti Shree",
    address: "Sector No. 8, Plot No. 22, Ulwe",
    city: "Ulwe, Navi Mumbai",
    status: "completed",
    area: "460 - 640 sq ft",
    image: "https://customer-assets.emergentagent.com/job_feature-branch-55/artifacts/ebb4gwm4_maruti_shree.png",
    description: "Maruti Shree is a completed residential project located in the rapidly developing Ulwe sector of Navi Mumbai. Thoughtfully designed with modern architecture and a classical touch, this project offers spacious 1 BHK and 2 BHK apartments that blend comfort with affordability.",
    highlights: [
      "Prime location in Ulwe, Navi Mumbai",
      "Spacious 1 BHK & 2 BHK apartments",
      "Modern amenities with quality construction",
      "Well-connected to Navi Mumbai Trans Harbour Link",
      "Close to schools, hospitals & shopping centres",
    ],
    amenities: ["Parking", "24/7 Security", "Power Backup", "Water Supply", "Lift"],
    configurations: [
      { type: "1 BHK", area: "460 sq ft" },
      { type: "2 BHK", area: "640 sq ft" },
    ],
  },
  {
    id: 2,
    slug: "alankara-heights",
    name: "Alankara Heights",
    address: "Plot No. 126, Sector R4, Pushpak Nagar",
    city: "Pushpak Nagar, Navi Mumbai",
    status: "completed",
    area: "475 - 650 sq ft",
    image: "https://customer-assets.emergentagent.com/job_feature-branch-55/artifacts/mq4hkkiu_Alankara.png",
    description: "Alankara Heights is a striking high-rise residential tower set in Pushpak Nagar, offering panoramic views and contemporary living. The building's elegant golden facade and modern design make it a landmark in the neighbourhood.",
    highlights: [
      "High-rise tower with panoramic views",
      "Premium quality construction",
      "Modern glass lobby and entrance",
      "Located in well-planned Pushpak Nagar layout",
      "Excellent connectivity to NH-4 and Panvel",
    ],
    amenities: ["Lobby", "Parking", "24/7 Security", "Power Backup", "Lift", "Water Tank"],
    configurations: [
      { type: "1 BHK", area: "475 sq ft" },
      { type: "2 BHK", area: "650 sq ft" },
    ],
  },
  {
    id: 3,
    slug: "shahid-apartment",
    name: "Shahid Apartment",
    address: "Khopoli",
    city: "Khopoli, Raigad",
    status: "completed",
    area: "465 - 640 sq ft",
    image: "https://customer-assets.emergentagent.com/job_feature-branch-55/artifacts/moxnqss7_Shahid_Apartment.png",
    description: "Shahid Apartment is a completed residential project in Khopoli featuring a clean, contemporary design with commercial spaces on the ground floor. The project provides comfortable living spaces in a well-planned layout with modern finishes.",
    highlights: [
      "Successfully delivered to happy homeowners",
      "Ground floor commercial spaces",
      "Clean contemporary architecture",
      "Serene location in Khopoli",
      "Value-for-money homes",
    ],
    amenities: ["Parking", "24/7 Security", "Power Backup", "Water Supply", "Lift"],
    configurations: [
      { type: "1 BHK", area: "465 sq ft" },
      { type: "2 BHK", area: "640 sq ft" },
    ],
  },
  {
    id: 4,
    slug: "shiv-siddhi",
    name: "Shiv Siddhi",
    address: "Kalyan - Thane",
    city: "Kalyan, Thane",
    status: "completed",
    area: "480 - 655 sq ft",
    image: "https://customer-assets.emergentagent.com/job_feature-branch-55/artifacts/bmbq3i9y_Shiv_sidhi.png",
    description: "Shiv Siddhi is a large-scale completed residential complex in the Kalyan-Thane region, comprising multiple wings and blocks. This township-style development offers a self-sufficient community with ample green spaces and modern facilities.",
    highlights: [
      "Large township-style development",
      "Multiple wings with 100+ units",
      "Lush green landscaping",
      "Well-established residential neighbourhood",
      "Excellent transport connectivity to Mumbai & Pune",
    ],
    amenities: ["Parking", "24/7 Security", "Power Backup", "Garden", "Lift", "Children Play Area"],
    configurations: [
      { type: "1 BHK", area: "480 sq ft" },
      { type: "2 BHK", area: "655 sq ft" },
    ],
  },
  {
    id: 5,
    slug: "neelkanteshwar-garden",
    name: "Neelkanteshwar Garden",
    address: "Koproli, Panvel",
    city: "Koproli, Panvel",
    status: "completed",
    area: "470 - 630 sq ft",
    image: "https://customer-assets.emergentagent.com/job_feature-branch-55/artifacts/ejy2l912_Neelkhanteshwarpng.png",
    description: "Neelkanteshwar Garden is a completed residential project in Koproli, Panvel. Inspired by the Neelkanth Residency design legacy, this project delivers quality construction with modern amenities and garden spaces in one of Navi Mumbai's growing areas.",
    highlights: [
      "Completed and delivered",
      "Located in high-growth Panvel area",
      "Thoughtful garden-themed design",
      "Close to Panvel railway station",
      "Near Navi Mumbai International Airport",
    ],
    amenities: ["Garden", "Parking", "24/7 Security", "Power Backup", "Lift", "Water Supply"],
    configurations: [
      { type: "1 BHK", area: "470 sq ft" },
      { type: "2 BHK", area: "630 sq ft" },
    ],
  },
  {
    id: 6,
    slug: "hariom-complex",
    name: "Hariom Complex",
    address: "Kamolhe, Navi Mumbai",
    city: "Kamolhe, Navi Mumbai",
    status: "completed",
    area: "455 - 620 sq ft",
    image: "https://customer-assets.emergentagent.com/job_feature-branch-55/artifacts/r3hzx0ex_hari_om.png",
    description: "Hariom Complex is a completed mixed-use development in Kamolhe, Navi Mumbai. The building features a vibrant orange and white facade with commercial spaces on the lower floors and comfortable residential apartments above.",
    highlights: [
      "Mixed-use development with commercial & residential",
      "Vibrant architectural design",
      "Ground floor commercial spaces",
      "Completed and fully occupied",
      "Excellent road connectivity in Navi Mumbai",
    ],
    amenities: ["Parking", "24/7 Security", "Power Backup", "Water Supply", "Lift", "CCTV"],
    configurations: [
      { type: "1 BHK", area: "455 sq ft" },
      { type: "2 BHK", area: "620 sq ft" },
    ],
  },
  {
    id: 7,
    slug: "alankara-paradise",
    name: "Alankara Paradise",
    address: "Sector Plot No. 67, Pushpak Nagar",
    city: "Pushpak Nagar, Navi Mumbai",
    status: "completed",
    area: "470 - 645 sq ft",
    image: "https://customer-assets.emergentagent.com/job_feature-branch-55/artifacts/1myqxdbw_alankara_paradise.png",
    description: "Alankara Paradise is a completed high-rise residential tower in Pushpak Nagar. Featuring dramatic illuminated balconies and a bold modern facade, this project redefines quality living in Navi Mumbai.",
    highlights: [
      "Completed high-rise residential tower",
      "Dramatic illuminated balcony design",
      "Premium specifications and finishes",
      "Located in the heart of Pushpak Nagar",
      "Surrounded by parks and civic amenities",
    ],
    amenities: ["Lobby", "Parking", "24/7 Security", "Power Backup", "Lift", "Intercom", "Water Tank"],
    configurations: [
      { type: "1 BHK", area: "470 sq ft" },
      { type: "2 BHK", area: "645 sq ft" },
    ],
  },
  {
    id: 8,
    slug: "sadguru",
    name: "Sadguru",
    address: "Navi Mumbai",
    city: "Navi Mumbai",
    status: "completed",
    area: "460 - 640 sq ft",
    image: "https://customer-assets.emergentagent.com/job_feature-branch-55/artifacts/9moun9r5_Sadguru.png",
    description: "Sadguru is a completed large-scale township development in Navi Mumbai. This sprawling complex offers a variety of home sizes from compact 1 BHK to spacious 2 BHK apartments, catering to diverse family needs within a well-planned community layout.",
    highlights: [
      "Large township with multiple blocks",
      "Wide range of flat sizes",
      "Community living with open spaces",
      "Fully developed infrastructure",
      "Excellent connectivity within Navi Mumbai",
    ],
    amenities: ["Parking", "24/7 Security", "Power Backup", "Garden", "Lift", "Children Play Area", "Community Hall"],
    configurations: [
      { type: "1 BHK", area: "460 sq ft" },
      { type: "2 BHK", area: "640 sq ft" },
    ],
  },
  {
    id: 9,
    slug: "gayatri-darshan",
    name: "Gayatri Darshan",
    address: "Mulund East",
    city: "Mulund East, Mumbai",
    status: "ongoing",
    area: "415 - 950 sq ft",
    image: "https://customer-assets.emergentagent.com/job_feature-branch-55/artifacts/ifcvkn1f_gayatri_new2.jpeg",
    description: "Gayatri Darshan is an ongoing premium high-rise project in Mulund East, Mumbai. The tower's distinctive architectural design with illuminated wave-shaped balconies creates a breathtaking visual at night, making it one of the most distinctive landmarks in the area.",
    highlights: [
      "Premium high-rise in Mulund East, Mumbai",
      "Distinctive illuminated balcony architecture",
      "Panoramic city views from upper floors",
      "Well-connected to Eastern Express Highway",
      "Close to Mulund railway station",
    ],
    amenities: ["Lobby", "Parking", "24/7 Security", "Power Backup", "Lift", "Intercom", "Gymnasium", "Rooftop"],
    configurations: [
      { type: "1 BHK", area: "415 sq ft" },
      { type: "2 BHK", area: "620 sq ft" },
      { type: "3 BHK", area: "950 sq ft" },
    ],
  },
  {
    id: 10,
    slug: "vamantas",
    name: "Vamantas",
    address: "Mulund East",
    city: "Mulund East, Mumbai",
    status: "upcoming",
    area: "450 - 600 sq ft",
    image: "https://customer-assets.emergentagent.com/job_feature-branch-55/artifacts/wkuekyhu_Gemini_Generated_Image_ewsxdxewsxdxewsx.png",
    description: "Vamantas is an upcoming premium residential tower in Mulund East, Mumbai, featuring lush green balconies, modern architecture, and vibrant commercial spaces at street level. Designed for those who seek a perfect blend of urban convenience and serene living.",
    highlights: [
      "Upcoming project — Book now at pre-launch prices",
      "Contemporary mixed-use development with retail at ground floor",
      "Green balconies on every floor for a sustainable lifestyle",
      "Excellent connectivity in Mulund East, Mumbai",
      "Close to Eastern Express Highway and Mulund station",
    ],
    amenities: ["Parking", "24/7 Security", "Power Backup", "Green Balconies", "Lift", "Retail Shops", "Water Supply"],
    configurations: [
      { type: "1 BHK", area: "450 sq ft" },
      { type: "2 BHK", area: "600 sq ft" },
    ],
  },
  {
    id: 11,
    slug: "neel-galaxy",
    name: "Neel Galaxy",
    address: "Navi Mumbai",
    city: "Navi Mumbai",
    status: "completed",
    area: "465 - 635 sq ft",
    image: "https://images.unsplash.com/photo-1570124748133-fc12a93e3653?w=500&h=300&fit=crop",
    description: "Neel Galaxy is a completed residential-cum-commercial development by Arrow Construction in Navi Mumbai. The project offers a blend of modern living spaces and vibrant commercial units, designed to cater to the needs of contemporary urban families.",
    highlights: [
      "Completed and delivered",
      "Mixed residential and commercial development",
      "Modern architectural design",
      "Excellent connectivity within Navi Mumbai",
      "Quality construction by Arrow Construction",
    ],
    amenities: ["Parking", "24/7 Security", "Power Backup", "Lift", "Water Supply", "CCTV"],
    configurations: [
      { type: "1 BHK", area: "465 sq ft" },
      { type: "2 BHK", area: "635 sq ft" },
    ],
  },
  {
    id: 12,
    slug: "nimbeshwar-kunj",
    name: "Nimbeshwar Kunj",
    address: "S. No. 4(1), Palidevad, Near New Panvel",
    city: "New Panvel, Raigad",
    status: "completed",
    area: "475 - 650 sq ft",
    image: "https://images.unsplash.com/photo-1559998852-f8ab898d889e?w=500&h=300&fit=crop",
    description: "Nimbeshwar Kunj is a completed mixed-use residential and commercial project located near New Panvel. The project features retail spaces on the ground floor and well-designed residential apartments above, in a well-connected location in the Panvel belt.",
    highlights: [
      "Completed and delivered",
      "Mixed-use development with commercial & residential units",
      "Ground floor retail spaces",
      "Well-connected to Panvel railway station and NH-48",
      "Quality construction by Arrow Construction",
    ],
    amenities: ["Parking", "24/7 Security", "Power Backup", "Lift", "Water Supply", "Retail Spaces"],
    configurations: [
      { type: "1 BHK", area: "475 sq ft" },
      { type: "2 BHK", area: "650 sq ft" },
    ],
  },
  {
    id: 13,
    slug: "poornima-heights",
    name: "Poornima Heights",
    address: "Mumbai",
    city: "Mumbai",
    status: "ongoing",
    area: "490 - 750 sq ft",
    image: "https://customer-assets.emergentagent.com/job_feature-branch-55/artifacts/xrlh1jcr_Cam%2003%20PURNIMA_EXT_NK_005_Opt%2001%20copy.jpg",
    description: "Poornima Heights is an ongoing premium residential tower by Arrow Construction featuring a striking twin-tower design with ground floor retail shops. The project offers elegant 1 BHK and 2 BHK apartments with premium finishes, set amidst lush greenery in Mumbai.",
    highlights: [
      "Ongoing project — book early for best pricing",
      "Striking twin-tower architectural design",
      "Premium retail spaces at ground floor",
      "Spacious 1 BHK & 2 BHK apartments",
      "Quality construction with modern finishes",
    ],
    amenities: ["Parking", "24/7 Security", "Power Backup", "Lift", "Water Supply", "Retail Shops", "CCTV"],
    configurations: [
      { type: "1 BHK", area: "490 sq ft" },
      { type: "2 BHK", area: "630 sq ft" },
      { type: "2 BHK (L)", area: "750 sq ft" },
    ],
  },
];

export const statusConfig = {
  ongoing: { label: "Ongoing", color: "bg-blue-100 text-blue-700 border border-blue-200" },
  completed: { label: "Completed", color: "bg-green-100 text-green-700 border border-green-200" },
  upcoming: { label: "Upcoming", color: "bg-amber-100 text-amber-700 border border-amber-200" },
};
